__turbopack_context__.v({
  "root": "QjGp4G_root",
  "rootgrayscale": "QjGp4G_rootgrayscale",
  "rootgrayscale_product_myCme": "QjGp4G_rootgrayscale_product_myCme",
  "rootgrayscale_product_myGme": "QjGp4G_rootgrayscale_product_myGme",
  "rootinteractable": "QjGp4G_rootinteractable",
  "rootproduct_myCme": "QjGp4G_rootproduct_myCme",
  "rootproduct_myEvaluations_grayscale": "QjGp4G_rootproduct_myEvaluations_grayscale",
  "rootproduct_myGme": "QjGp4G_rootproduct_myGme",
});
